import React from 'react';
import {Button} from "react-bootstrap";
import Security from "../../components/security";
import {withRouter} from "react-router-dom";
import ScreenComponent from "../../components/screenComponent";
import {Get, Post} from "../../components/request";
import screens from "../../screens";
import EditTable from "../../components/editTable";
import Adresse from "../../forms/adresse";
import MoyenContact from "../../forms/moyenContact";
import loadParameters from "../../components/loadParameters";
import MyCard from "../../components/myCard";
import Bourse from "./bourse";
import ChoixLangue from "./choixLangue";
import ChoixDiplome from "./choixDiplome";
import {getRoute} from "../../breadcrumb/utils";
import {toast} from "react-toastify";

class Reinscription extends ScreenComponent {

    constructor(props) {
        super(props);
        this.state = {
            etape: 0,
            adresses: [],
            contacts: [],
            diplomes: null,

            bourse: {
                checked: false,
                BourseNumBourse: "",
                BourseFichierID: null,
                filename: "",
            },
            CoursLangue3ID: null,
            NeedLangue3: false,
            DiplomeID: null,
        };
    }

    async componentDidMount() {
        super.componentDidMount();
        await loadParameters(this, "TypeAdresseID,TypeMoyenContactID,PaysID,CoursLangue3ID");
        await this.loadInitialData();
    }

    async loadInitialData() {
        let {body} = await Get(`/v1/extranet/student/${screens.Reinscription}`);

        let diplomes = null;
        if (body.DiplomeID) {
            diplomes = [];
            body.DiplomeID.map((v) => diplomes.push({value: Number(v.ID), label: v.Display}));
        }

        this.setState({
            diplomes: diplomes,
            CoursLangue3ID: this.state.parameters.CoursLangue3ID.find(f => f.value === body.CoursLangue3ID),
            NeedLangue3: body.NeedLangue3
        });

        ({body} = await Get(`/v1/extranet/student/${screens.Reinscription}01`));

        this.setState({
            adresses: body
        });

        ({body} = await Get(`/v1/extranet/student/${screens.Reinscription}02`));

        this.setState({
            contacts: body
        });
    }

    async save(screen, data) {
        let result = await Post(`/v1/extranet/student/${screens.Reinscription}0${screen}`, data, "Sauvegarde en cours..", {render: "Sauvegarde réussie !"}, {render: "Erreur lors de la sauvegarde"});

        await new Promise((resolve) => {
            setTimeout(resolve, 500)
        });

        return result;
    }

    async updateEtape(event) {
        event.persist();

        if (!Security.getFirstAccesReinscription()) {
            this.props.history.push(getRoute(screens.PAE));
        }

        let saved = true;

        if (event.target !== this.precedent) {

            // eslint-disable-next-line default-case
            switch (this.state.etape) {
                case 1:
                    if (this.state.adresses < 1 || !this.state.adresses.some(s => s.TypeAdresse === "Domicile Légal")) {
                        toast.warn("Veuillez renseigner au minimum une adresse de type \"Domicile Légal\".");
                        return;
                    }
                    break;
                case 2:
                    if (this.state.contacts < 1 || !this.state.contacts.some(s => s.TypeMoyenContact === "Email")) {
                        toast.warn("Veuillez renseigner au minimum un moyen de contact de type \"Email\".");
                        return;
                    }
                    break;
                case 3:
                    saved = await this.save(this.state.etape, this.state.bourse);
                    break;
                case 4:
                    saved = await this.save(this.state.etape, this.state.CoursLangue3ID);

                    if (saved && !this.state.diplomes)
                        this.props.history.push(getRoute(screens.PAE));
                    break;
                case 5:
                    saved = await this.save(this.state.etape, this.state.DiplomeID);

                    if (saved)
                        this.props.history.push(getRoute(screens.PAE));
                    break;
            }
        }

        if (saved) {
            this.setState(prevState => ({
                etape: event.target === this.precedent ? --prevState.etape : ++prevState.etape
            }));
        }

    }

    updateBourse(id, name = "") {
        if (typeof id === "number") {
            this.setState(prevState => ({
                bourse: {
                    ...prevState.bourse,
                    BourseFichierID: id,
                    BourseJustificatif: true,
                    filename: name
                }
            }));
        } else if (typeof id === "string") {
            if (id !== this.state.bourse.BourseNumBourse) {
                this.setState(prevState => ({
                    bourse: {
                        ...prevState.bourse,
                        BourseNumBourse: id
                    }
                }));
            }
        } else {
            this.setState(prevState => {

                let previous = {...prevState.bourse};

                if (prevState.bourse.checked) {
                    previous = {
                        BourseNumBourse: "",
                        BourseFichierID: null,
                        BourseJustificatif: false,
                        filename: "",
                    }
                }

                return {
                    bourse: {
                        ...previous,
                        checked: !prevState.bourse.checked
                    }
                }
            });
        }
    }

    updateLangue(value) {
        this.setState({
            CoursLangue3ID: value
        });
    }

    updateDiplome(value) {
        this.setState({
            DiplomeID: value
        });
    }

    start() {
        const limit = Security.getLimitAccesReinscription();
        return (
            <section className={!limit ? "text-center" : ""}>
                {limit
                    ? <p>
                        Madame, Monsieur,
                        <br/><br/>

                        Vous avez introduit une demande de réinscription au sein de notre haute école.
                        <br/><br/>

                        Cette demande est toutefois refusée, conformément à l’article 96 du décret «Paysage» du 7
                        novembre 2013 dans la mesure où les informations que vous nous avez communiquées vous placent
                        dans le statut d’étudiant non finançable et ce, pour le motif suivant :
                        <br/><br/>

                        Au terme de votre première inscription dans ce cursus, vous n’avez pas acquis ou valorisé les
                        crédits associés à une unité d’enseignement minimum parmi les unités d’enseignement du premier
                        bloc annuel.

                        <br/><br/>

                        Modalités de recours :
                        <br/><br/>

                        Tout étudiant dont l’inscription est refusée peut faire appel de la décision devant la
                        commission de recours interne de la Haute Ecole, qui peut invalider le refus.
                        <br/><br/>

                        Sous peine d’irrecevabilité, l’étudiante ou l’étudiant utilisera le formulaire et complètera le
                        tableau relatif à son parcours académique, téléchargeable via le formulaire de recours. Ce
                        formulaire est disponible en ligne, sur le site de la Haute Ecole, à l’adresse suivante :

                        <a href="https://he-ichec-ecam-isfsc.be/"> https://he-ichec-ecam-isfsc.be/</a>

                        <br/><br/>
                        Le recours sera introduit en ligne, dans les 10 jours calendriers suivant la réception de la
                        notification de refus. L’étudiante ou l’étudiant motive son recours en raison des circonstances
                        exceptionnelles pouvant, à ses yeux, légitimer une inscription en tant qu’étudiante ou étudiant
                        non-finançable. Le cas échéant, ce recours devra s’accompagner de pièces écrites de nature à
                        prouver le caractère exceptionnel de ces circonstances. L’étudiante ou l’étudiant précise en
                        outre les moyens envisagés pour améliorer ses résultats et redevenir étudiante ou étudiant
                        finançable.
                        <br/><br/>

                        Le non-respect des modalités et délais entraîne l’irrecevabilité du recours.
                        <br/><br/>

                    </p>
                    : <Button style={{"fontSize": "2rem"}}
                              size={"lg"}
                              variant={"secondary"}
                              onClick={this.updateEtape.bind(this)}>Démarrer</Button>}
            </section>
        );
    }

    render() {
        const navBtn = (
            <div className={"mb-5"}>
                <Button ref={r => this.precedent = r}
                        onClick={this.updateEtape.bind(this)}
                        size={"lg"}
                        variant={"outline-dark"}
                        className={""}>
                    Précédent
                </Button>
                <Button onClick={this.updateEtape.bind(this)}
                        size={"lg"}
                        variant={"outline-dark"}
                        className={"float-right"}>
                    Suivant
                </Button>
            </div>
        );

        let header = null;
        let body = null;
        let paragraph = null;
        let columns = {};
        let table = [];
        let form = null;
        let screenID = screens.Reinscription + "0" + this.state.etape;

        if (this.state.etape === 4 && !this.state.NeedLangue3) {
            if (this.state.diplomes) this.state.etape = 5;
            else this.props.history.push(getRoute(screens.PAE));
        }

        switch (this.state.etape) {
            case 1:
                columns = {
                    "Type": "TypeAdresse",
                    "Ligne 1": "AdresseLigne1",
                    "Code Postal": "AdresseCodePostal",
                    "Localité": "AdresseLocalite",
                    "Pays": "Pays"
                };
                paragraph = (<p>Veuillez le cas échéant actualiser vos adresses s'il vous plaît.</p>);
                table = this.state.adresses;
                form = Adresse;
                break;
            case 2:
                columns = {
                    "Type": "TypeMoyenContact",
                    "Contact": "MoyenContactValeur"
                };
                paragraph = (<p>Veuillez le cas échéant actualiser vos moyens de contact s'il vous plaît.</p>);
                table = this.state.contacts;
                form = MoyenContact;
                break;
            case 3:
                header = "Demande de bourse";
                body = <Bourse {...this.state.bourse}
                               onChange={this.updateBourse.bind(this)}/>;
                break;
            case 4:
                header = "Choix de la langue";
                body = <ChoixLangue selected={this.state.CoursLangue3ID}
                                    onChange={this.updateLangue.bind(this)}
                                    parameters={this.state.parameters}/>;
                break;
            case 5:
                header = "Choix du master";
                body = <ChoixDiplome selected={this.state.DiplomeID}
                                     onChange={this.updateDiplome.bind(this)}
                                     parameters={this.state.diplomes}/>;
                break;
            default:
                return this.start();
        }

        if (this.state.etape < 3) {
            return (
                <section>
                    {navBtn}
                    {paragraph}
                    <EditTable columns={columns}
                               parameters={this.state.parameters}
                               table={table}
                               form={form}
                               screenID={screenID}
                               reload={this.loadInitialData.bind(this)}/>
                </section>
            );
        } else {
            return (
                <section>
                    {navBtn}
                    <MyCard header={header}
                            body={body}/>
                </section>
            );
        }

    }
}

export default withRouter(Reinscription);